import axios from "axios";
import { IOrderDto } from "../../../components/order/interfaces/order-dto.interface";

export const htmlId: string = 'orders-list';
const prefix: string = 'Orders/';

export const getOrders= (dto: IOrderDto) => {
    return axios.post(`${prefix}GetAll`, dto);
}